import * as React from 'react'
const SvgComponent = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={144}
    height={136}
    preserveAspectRatio="xMidYMid meet"
    fill="none"
    shapeRendering="geometricPrecision"
    vectorEffect="non-scaling-stroke"
    {...props}
  >
    <path
      fill="#fff"
      d="M96.5 33.216c-7.047-7.9-16.814-11.362-21.808-7.731-4.994 3.63-3.326 12.98 3.721 20.88 7.047 7.902 16.815 11.363 21.809 7.732 4.994-3.63 3.331-12.98-3.721-20.88Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.6}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M96.5 33.216c-7.047-7.9-16.814-11.362-21.808-7.731-4.994 3.63-3.326 12.98 3.721 20.88 7.047 7.902 16.815 11.363 21.809 7.732 4.994-3.63 3.331-12.98-3.721-20.88Z"
    />
    <path
      fill="currentColor"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      className="gray-element"
      d="m93.073 39.11-2.664-3.66a.193.193 0 0 0-.226-.067l-4.485 1.651-4.581-6.29c-.029-.033-.074-.05-.119-.033l-2.703.995c-.063.023-.085.102-.046.159l4.542 6.244-4.383 1.612c-.119.045-.17.192-.09.294l2.663 3.659c.051.068.142.102.226.068l4.485-1.652 4.582 6.29c.028.033.073.05.118.033l2.704-.995c.062-.023.084-.102.045-.158l-4.542-6.244 4.384-1.612a.195.195 0 0 0 .09-.294Z"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M51.238 74.396s3.427 3.467 9.614 2.556a1.13 1.13 0 0 1 1.284.922c.074.464.102.809.113 1.035a.79.79 0 0 0 .283.577l4.977 4.134c2.568 1.669 4.293 4.4 4.57 7.449.023.22.028.418.028.582l.594 11.747a3.504 3.504 0 0 1-1.923 3.258 9.531 9.531 0 0 1-9.354-.435L44.179 95.418a6.345 6.345 0 0 1-2.958-5c-.164-2.686-.345-1.674-.526-4.96-.531-9.433 7.884-10.09 10.05-10.106a.502.502 0 0 0 .504-.51v-1.306"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={0.8}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M51.238 74.396s3.427 3.467 9.614 2.556a1.13 1.13 0 0 1 1.284.922c.074.464.102.809.113 1.035a.79.79 0 0 0 .283.577l4.977 4.134c2.568 1.669 4.293 4.4 4.57 7.449.023.22.028.418.028.582l.594 11.747a3.504 3.504 0 0 1-1.923 3.258 9.531 9.531 0 0 1-9.354-.435L44.179 95.418a6.345 6.345 0 0 1-2.958-5c-.164-2.686-.345-1.674-.526-4.96-.531-9.433 7.884-10.09 10.05-10.106a.502.502 0 0 0 .504-.51v-1.306"
    />
    <path
      fill="currentColor"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      className="gray-element"
      d="M47.284 59.487c-.062-.367-1.64-2.188 2.127-4.496 3.767-2.307 13.675-5.35 15.683-2.008 1.703 2.834-.05 6.408-1.47 7.619-.311.265-.368.7-.17 1.063.74 1.346.571 3.8-1.453 5.118.062.572.118 1.431.163 2.144a1.567 1.567 0 0 1-1.199 1.623s-.118-4.072-2.307-2.856c-.995.554-.837 1.55-.498 2.33.334.764.22 1.646-.333 2.268l-.215.237a5.569 5.569 0 0 1-5.628 1.663l-1.108-.3-4.112-8.608a4.523 4.523 0 0 1 .096-5.214l.43-.588-.006.005Z"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={0.6}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M60.417 74.441s5.135.119 5.384-4.559c.243-4.683-1.43-11.61-1.43-11.61M61.452 74.486v2.364M61.763 95.288c0 .238.77 11.532.77 11.532"
    />
    <path
      fill="#fff"
      d="M55.853 9.474C48.8 1.573 39.038-1.89 34.044 1.742c-4.994 3.631-3.331 12.98 3.722 20.881 7.047 7.901 16.814 11.363 21.808 7.732 4.994-3.631 3.331-12.98-3.721-20.881Z"
    />
    <path
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.6}
      d="M55.853 9.474C48.8 1.573 39.038-1.89 34.044 1.742c-4.994 3.631-3.331 12.98 3.722 20.881 7.047 7.901 16.814 11.363 21.808 7.732 4.994-3.631 3.331-12.98-3.721-20.881Z"
    />
    <path
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m43.908 23.783-5.933-10.237a.236.236 0 0 1 .09-.328l2.2-1.256a.237.237 0 0 1 .328.09l3.524 6.024 7.782-4.694a.266.266 0 0 1 .362.096l2.347 4.05c.08.13.029.3-.101.379l-10.401 5.932a.14.14 0 0 1-.193-.05"
    />
    <path
      fill="#fff"
      d="M11.246 44.392s3.427 3.467 9.615 2.556a1.13 1.13 0 0 1 1.284.922c.073.464.101.81.107 1.035a.79.79 0 0 0 .283.577l4.977 4.135c2.567 1.668 4.293 4.4 4.57 7.448.017.22.028.419.028.583l.594 11.747a3.504 3.504 0 0 1-1.923 3.258 9.532 9.532 0 0 1-9.355-.436L4.182 65.415a6.345 6.345 0 0 1-2.958-5c-.164-2.687-.345-1.674-.526-4.96-.532-9.434 7.884-10.09 10.05-10.107a.502.502 0 0 0 .504-.51v-1.306"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={0.8}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M11.246 44.392s3.427 3.467 9.615 2.556a1.13 1.13 0 0 1 1.284.922c.073.464.101.81.107 1.035a.79.79 0 0 0 .283.577l4.977 4.135c2.567 1.668 4.293 4.4 4.57 7.448.017.22.028.419.028.583l.594 11.747a3.504 3.504 0 0 1-1.923 3.258 9.532 9.532 0 0 1-9.355-.436L4.182 65.415a6.345 6.345 0 0 1-2.958-5c-.164-2.687-.345-1.674-.526-4.96-.532-9.434 7.884-10.09 10.05-10.107a.502.502 0 0 0 .504-.51v-1.306"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={0.6}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M20.414 42.079s4.078 1.374 5.09-2.72c1.125-4.548-1.126-11.091-1.126-11.091M21.454 44.477v2.364M21.771 65.279c0 .237.77 11.532.77 11.532"
    />
    <path
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M22.11 38.51c-.028-.47.645-1.357.968-1.697 1.894-2.013 1.029-4.977 1.3-5.208 1.426-1.21 3.417-2.376 1.714-5.21-.842-1.408-6.142-4.377-10.061-3.726-13.614 2.25-9.977 15.847-10.418 18.703-.436 2.817-1.94 1.437-2.72 4.971C1.06 54.63 17.868 58.656 22.777 57.236c4.915-1.42 4.677-6.034 1.657-9.054-1.402-1.403-2.127-6.273-2.33-9.666"
    />
    <path
      fill="#fff"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M23.858 38.748c-.05-.577-1.391-3.648-3.037-2.2-1.21 1.063.543 3.144 1.838 3.755M136.724 61.557c-7.047-7.9-16.814-11.362-21.808-7.731-4.994 3.631-3.326 12.98 3.721 20.881 7.047 7.901 16.814 11.362 21.809 7.731 4.994-3.63 3.331-12.98-3.722-20.88Z"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.6}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M136.724 61.557c-7.047-7.9-16.814-11.362-21.808-7.731-4.994 3.631-3.326 12.98 3.721 20.881 7.047 7.901 16.814 11.362 21.809 7.731 4.994-3.63 3.331-12.98-3.722-20.88Z"
    />
    <path
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="m125.91 75.872-5.933-10.237a.236.236 0 0 1 .091-.328l2.2-1.256a.237.237 0 0 1 .328.09l3.524 6.024 7.782-4.694a.267.267 0 0 1 .362.096l2.347 4.05c.079.13.028.3-.102.379l-10.406 5.933a.14.14 0 0 1-.193-.051"
    />
    <path
      fill="#fff"
      d="M95.573 102.403s3.326 3.365 9.326 2.483a1.094 1.094 0 0 1 1.244.894c.074.452.102.786.108 1.001a.774.774 0 0 0 .271.56l4.83 4.01c2.489 1.617 4.169 4.27 4.434 7.228.017.214.029.407.029.565l.577 11.402a3.39 3.39 0 0 1-1.867 3.162 9.248 9.248 0 0 1-9.077-.419l-16.735-10.486a6.156 6.156 0 0 1-2.868-4.852c-.158-2.608-.334-1.629-.515-4.813-.514-9.151 7.653-9.796 9.757-9.807a.488.488 0 0 0 .486-.492v-1.267"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={0.8}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M95.573 102.403s3.326 3.365 9.326 2.483a1.094 1.094 0 0 1 1.244.894c.074.452.102.786.108 1.001a.774.774 0 0 0 .271.56l4.83 4.01c2.489 1.617 4.169 4.27 4.434 7.228.017.214.029.407.029.565l.577 11.402a3.39 3.39 0 0 1-1.867 3.162 9.248 9.248 0 0 1-9.077-.419l-16.735-10.486a6.156 6.156 0 0 1-2.868-4.852c-.158-2.608-.334-1.629-.515-4.813-.514-9.151 7.653-9.796 9.757-9.807a.488.488 0 0 0 .486-.492v-1.267"
    />
    <path
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M94.736 83.366c3.66-2.24 12.352-2.15 14.298 1.097 1.651 2.749-3.105 3.54-3.043 5.356.181 5.356.017 4.841.062 5.537a1.528 1.528 0 0 1-1.165 1.578l-.238-.6s-.667-.853-1.889-.424c-1.04.368-.808 1.505-.48 2.263.322.74.215 1.6-.323 2.2l-.209.232a5.409 5.409 0 0 1-5.463 1.617l-1.075-.294-3.705-6.623c-2.132-5.537-.435-9.683 3.224-11.928"
    />
    <path
      stroke="currentColor"
      strokeMiterlimit={10}
      strokeWidth={0.6}
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M104.481 102.448s4.988.119 5.22-4.422c.238-4.542-1.386-11.267-1.386-11.267M105.482 102.488v2.296M105.787 122.679c0 .232.747 11.193.747 11.193"
    />
    <path
      fill="currentColor"
      className="gray-element"
      shapeRendering="geometricPrecision"
      vectorEffect="non-scaling-stroke"
      d="M99.849 101.193c0 3.19-2.794 5.78-6.239 5.78-3.444 0-6.238-2.59-6.238-5.78 0-3.19 2.794-5.78 6.238-5.78 3.445 0 6.239 2.59 6.239 5.78Z"
    />
  </svg>
)
export default SvgComponent
